export const MoveHoursViewOptionsStateKey = 'move-hours-view-options';

export const MoveHoursSelectedFilterListStateKey = 'move-hours-selected-filter-list';
